export default __webpack_public_path__ + "static/media/inbox.cdfe2359.svg";